export class ContactForm {
  name!: string;
  email!: string;
  mobile!: string;
  message!: string;

  get isNameValid(): boolean{
    return this.name != null && this.name.length > 0;
  }
  get isEmailValid(): boolean {
    const rxRule = new RegExp('^([\\w\\.\\-\\+]+)@([\\w\\-]+)((\\.(\\w){2,})+)$');
    return this.email != null && rxRule.test(this.email);
  }
  get isEmailShowValidator(): boolean {
    return !this.isEmailValid && this.email != null && this.email.length > 0;
  }
  get isMobileValid(): boolean {
    const rxRule = new RegExp('^[0-9]{9}$');
    return this.mobile != null && rxRule.test(this.mobile);
  }
  get isMobileShowValidator(): boolean {
    return this.mobile != null && this.mobile.length > 0 && !this.isMobileValid;
  }
  get isMessageValid(): boolean{
    return this.message != null && this.message.length > 0;
  }
}
